import Head from 'next/head';
import { ReactElement } from 'react';

import Section from 'components/ToolResetPassword';

const ResetPassword = (): ReactElement => {
  return (
    <>
      <Head>
        <title>Reset password | Huzzle</title>
        <meta
          name="description"
          content="Huzzle brings all stakeholders in a student's career-life together."
        />
      </Head>
      <Section isRecruiter />
    </>
  );
};

export default ResetPassword;
